import { Action, AppDispatch, AppThunk } from '../../definitions/types';
import * as Actions from './actions-consts';

export function preselectIndustry(industry: string): AppThunk {
  return (dispatch: AppDispatch) => {
    dispatch(setIndustry(industry));
    dispatch(skipIndustryView());
  };
}

export function preselectProduct(product: string): AppThunk {
  return (dispatch: AppDispatch) => {
    dispatch(setPreSelectedProduct(product));
  };
}

export function shouldJumpToIndustryView(): AppThunk {
  return (dispatch: AppDispatch) => {
    dispatch(jumpToIndustryView(true));
  };
}

export function setIndustry(industry: string): Action<string> {
  return {
    type: Actions.SET_INDUSTRY,
    payload: industry,
    meta: {
      tracked: { action: 'industry', label: 'set' },
    },
  };
}

export function setOther(industry: string): Action<string> {
  return {
    type: Actions.SET_OTHER,
    payload: industry,
  };
}

export function setSelectedProduct(selectedProduct: string): Action<string> {
  return {
    type: Actions.SET_PRODUCT,
    payload: selectedProduct,
    meta: {
      tracked: { action: 'product', label: 'set' },
    },
  };
}

export function setPreSelectedProduct(preSelectedProduct: string): Action<string> {
  return {
    type: Actions.SET_PRE_SELECTED_PRODUCT,
    payload: preSelectedProduct,
  };
}

export function skipIndustryView(): Action<void> {
  return {
    type: Actions.SKIP_INDUSTRY_VIEW,
    meta: {
      tracked: { action: 'industry-view', label: 'skip' },
    },
  };
}

export function jumpToIndustryView(skipIt: boolean): Action<boolean> {
  return {
    type: Actions.SKIP_CATEGORY_VIEW,
    payload: skipIt,
    meta: {
      tracked: { action: 'category-view', label: 'skip' },
    },
  };
}

export function showWebsiteThreeMonthDiscountBadge(): Action<boolean> {
  return {
    type: Actions.SHOW_THREE_MONTH_DISCOUNT_BADGE,
    meta: {
      tracked: { action: 'three-month-discount-badge', label: 'show' },
    },
  };
}
